
<html>
<head>
<title>Maintenance Information</title>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
</head>
<div [ngSwitch]="maintenanceType">
<ng-container *ngSwitchCase="'MAINTENANCE_GENERAL'">
    <ng-template [ngTemplateOutlet]="general"></ng-template>
</ng-container>

<ng-container *ngSwitchCase="'MAINTENANCE_MERGE'">
    <ng-template [ngTemplateOutlet]="merge"></ng-template>
</ng-container>

<ng-container *ngSwitchCase="'MAINTENANCE_MEDDRA'">
    <ng-template [ngTemplateOutlet]="meddra"></ng-template>
</ng-container>
</div>
</html>

<ng-template #general>
<body>Dear EudraVigilance User, <p>
The European Medicines Agency is currently carrying out essential maintenance activities on the user and organisation management on the application you are accessing in.<br><br>
During this period this application is not currently accessible.<br>
</p>
<p>We apologise for any inconvenience caused.</p>
<p>Please contact EMA IT Service Desk for any questions related to this announcement.</p>
<p>The EudraVigilance Team</p>
<p>
<p>
</body>
</ng-template>

<ng-template #merge>
<body>Dear EudraVigilance Users, <p>
Please allow us to inform you that essential EudraVigilance maintenance work on user and organisation management will be carried out today. Should this need to be postponed</p>
<b>Electronic submission of ICSRs and XEVPRMs:</b>
<p>
These maintenance activities will have negligible impact on the electronic submission of ICSRs and XEVPRMs via the EVWEB interface or the EV gateway: These message types can be submitted to EudraVigilance during this period; Message Delivery Notifications (MDN) will be returned as usual, but acknowledgement messages (ACKs) will only be returned after the completion of the maintenance work and the processing of the messages.
</p>
<b>EVWEB reporting of ICSRs:</b>
<p>
There is no impact on the availability of EVWEB for the reporting of ICSRs and ICSR forms from the EVDAS links to EVWEB will be available during this maintenance period. However, please note that you will need to access these applications directly rather than via the EV restricted area by using the URLs below:
<ul>
	<li>EudraVigilance Human: <a [href]='eudravigilanceUrl'>{{eudravigilanceUrl}}</a></li>
</ul>
<b>EVWEB reporting of XEVPRMs:</b>
<p>
The EVWEB functionality for electronic reporting of data on medicines (XEVMPDweb) to the XEVMPD will be unavailable.
</p>
<b>EudraVigilance restricted area:</b>
<p>
The Human EudraVigilance restricted area will not be available during this period and a maintenance page will be displayed instead.
</p>
<b>MAHs ICSR download requests:</b>
<p>
Please note that it will not be possible to perform any ICSR download requests on today. Please note that in the event this essential maintenance activity is taking longer than expected, the data being made available for L2A/B ICSR download might be delayed to the following day (please check the last processing date in the ICSR download tab of the EVWEB interface). 
</p>
<p>
We thank you for your cooperation and understanding.
</p>
</body>
</ng-template>

<ng-template #meddra>
    <body>Dear EudraVigilance Users, <p>
Please allow us to inform you that essential EudraVigilance maintenance work on user and organisation management is being carried out. Should this need to be postponed, a new communication will be sent to inform the EudraVigilance users.
</p>
<b>Electronic submission of ICSRs and XEVPRMs:</b>
<p>
These maintenance activities will have negligible impact on the electronic submission of ICSRs and XEVPRMs via the EVWEB interface or the EV gateway: These message types can be submitted to EudraVigilance during this period; Message Delivery Notifications (MDN) will be returned as usual, but acknowledgement messages (ACKs) will only be returned after the completion of the maintenance work and the processing of the messages.
</p>
<b>EVWEB reporting of ICSRs:</b>
<p>
The EVWEB functionality for electronic reporting of ICSRs by national Competent Authorities (NCAs), marketing authorisation holders (MAHs) and sponsors of clinical trials (sponsors) will be unavailable.
</p>
<b>EVWEB reporting of XEVPRMs:</b>
<p>
The EVWEB functionality for electronic reporting of data on medicines (XEVMPDweb) to the XEVMPD will be unavailable.
</p>
<b>EudraVigilance restricted area:</b>
<p>
The Human EudraVigilance restricted area will not be available during this period and a maintenance page will be displayed instead.
</p>
<b>ICSR download requests:</b>
<p>
Please note that it will not be possible to perform any ICSR download requests on that day. Please note that in the event this essential maintenance activity is taking longer than expected, the data being made available for L2A/B ICSR download might be delayed to the following data (please check the last processing date in the ICSR download tab of the EVWEB interface). 
We thank you for your cooperation and understanding.
</p>
</body>
</ng-template>